import { NavLink, Outlet } from "react-router-dom";

export function SuperadminLayout() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Superadmin</h1>
          <p className="page-subtitle">Manage workspaces, Meta connections, feature flags, and templates.</p>
        </div>
      </header>
      <nav className="subnav">
        <NavLink end to="/superadmin" className={({ isActive }) => (isActive ? "subnav-item active" : "subnav-item")}>
          Workspaces
        </NavLink>
        <NavLink to="/superadmin/new" className={({ isActive }) => (isActive ? "subnav-item active" : "subnav-item")}>
          Add workspace
        </NavLink>
        <NavLink to="/superadmin/tools" className={({ isActive }) => (isActive ? "subnav-item active" : "subnav-item")}>
          Tools
        </NavLink>
        <NavLink to="/superadmin/feature-flags" className={({ isActive }) => (isActive ? "subnav-item active" : "subnav-item")}>
          Feature flags
        </NavLink>
        <NavLink to="/superadmin/system-templates" className={({ isActive }) => (isActive ? "subnav-item active" : "subnav-item")}>
          System templates
        </NavLink>
        <NavLink to="/superadmin/docs" className={({ isActive }) => (isActive ? "subnav-item active" : "subnav-item")}>
          Docs
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
